export const calculateScatterPlotInterval = (
  min: number,
  max: number,
  targetTicks = 8
): number => {
  const range = max - min;
  if (!range) return 1;

  const rough = range / (targetTicks - 1);
  const exp = Math.floor(Math.log10(rough));
  const frac = rough / 10 ** exp;

  const nice = frac <= 1 ? 1 : frac <= 2 ? 2 : frac <= 5 ? 5 : 10;

  return nice * 10 ** exp;
};
